import React, { useEffect, useState } from 'react'

import {
  Autocomplete as MUIAutocomplete,
  CircularProgress,
  InputAdornment,
  TextField,
} from '@mui/material'
import { getSimpleTyreSize, getTyreSize } from '../../../utils/tyreSize'
import { Controller } from 'react-hook-form'

const TyreSizeFieldRendered = React.forwardRef(
  (
    {
      field,
      fieldState,
      formState,
      defaultValue,
      options,
      label,
      placeholder,
      inputProps = {},
      InputProps = {},
      textFieldProps = {},
      ...rest
    },
    ref
  ) => {
    const [inputValue, setInputValue] = useState('')
    const [value, setValue] = useState(defaultValue ?? null)

    useEffect(() => {
      field.onChange(value ?? undefined)
      // eslint-disable-next-line
    }, [value])

    useEffect(() => {
      if (field.value == null) {
        setValue(null)
        return
      }
      const fieldValueTyreSize = getTyreSize(field.value)
      if (fieldValueTyreSize && getTyreSize(value) !== fieldValueTyreSize) {
        setValue(field.value)
        setInputValue(getSimpleTyreSize(field.value))
      }
      // eslint-disable-next-line
    }, [field.value])

    return (
      <MUIAutocomplete
        ref={ref}
        options={options}
        isOptionEqualToValue={(option, value) => getTyreSize(option) === getTyreSize(value)}
        onChange={(e, option) => setValue(option)}
        value={value}
        inputValue={inputValue}
        renderOption={(props, option) => <li {...props}>{getTyreSize(option)}</li>}
        getOptionLabel={(option) => option.id}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        autoHighlight
        openOnFocus
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue.replace(/[^\d\w.]+/g, ''))
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            error={Boolean(fieldState.error)}
            helperText={fieldState.error?.message}
            InputProps={{
              ...params.InputProps,
              endAdornment: rest.loading && (
                <InputAdornment position='end'>
                  <CircularProgress size={16} />
                </InputAdornment>
              ),
              ...InputProps,
            }}
            inputProps={{
              ...params.inputProps,
              ...inputProps,
            }}
            {...textFieldProps}
          />
        )}
        {...rest}
      />
    )
  }
)

const TyreSizeField = React.forwardRef(
  ({ control, name, rules, defaultValue, label, placeholder, options, setValue, ...rest }, ref) => {
    return (
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        setValue={setValue}
        render={(props) => (
          <TyreSizeFieldRendered
            {...props}
            options={options}
            defaultValue={defaultValue}
            label={label}
            placeholder={placeholder}
            name={name}
            {...rest}
            ref={ref}
          />
        )}
      />
    )
  }
)

export default TyreSizeField
